import { asDate } from "./as-date";
import { toFullDate } from "./full-date";
import type {
    IsoAndUnixTimestamp,
    WithUnixTimestamp} from "./iso-and-unix";
import {
    isoAndUnixFactory
} from "./iso-and-unix";
import { toUnix } from "./unix";

// type DateTime = {
//     readonly _type: "DATE_TIME";
//     readonly iso: IsoTimestamp;
//     /**
//      * seconds since Jan 01 1970 UTC
//      */
//     readonly unix: UnixTimestamp;
//     /**
//      * Ex: 20200101
//      */
//     readonly fullDate: number; // e.g. 20200101
//     readonly dayOfMonth: number;
//     readonly dayOfWeek: number; // 0-6
//     readonly hour: number; // 0-23
//     readonly minute: number; // 0-59
//     readonly quarter: number; // minute 0-14 = 1, 15-29 = 2, 30-44 = 3, 45-59 = 4
//     readonly half: number; // minute 0-29 = 1, 30-59: 2
// };

// const calcQuarter = (value: number) => {
//     const minute = setWithinRange(value, { min: 0, max: 59 });
//     if (minute < 15) return 1;
//     if (minute < 30) return 2;
//     if (minute < 45) return 3;
//     return 4;
// };

// const calcHalf = (value: number) => {
//     const minute = setWithinRange(value, { min: 0, max: 59 });
//     if (minute < 30) return 1;
//     return 2;
// // };

// const createDateTime = (date: Date): DateTime => {
//     return {
//         _type: "DATE_TIME",
//         iso: date.toISOString() as IsoTimestamp,
//         unix: toUnix(date),
//         fullDate: parseInt(
//             `${date.getUTCFullYear()}${("0" + (date.getUTCMonth() + 1)).slice(
//                 -2
//             )}${("0" + date.getUTCDate()).slice(-2)}`,
//             10
//         ),
//         dayOfMonth: date.getUTCDate(),
//         dayOfWeek: getDayOfWeekAsNumber(date),
//         hour: date.getUTCHours(),
//         minute: date.getUTCMinutes(),
//         half: calcHalf(date.getUTCMinutes()),
//         quarter: calcQuarter(date.getUTCMinutes()),
//     };
// };

/**
 * Returns hour as integer. \
 * E.g. 07
 * @param {IsoAndUnixTimestamp} input
 * @returns
 */
function getHour(input: Date): string;
function getHour(input: IsoAndUnixTimestamp): string;
function getHour(input: Date | IsoAndUnixTimestamp): string {
    const date = input instanceof Date ? input : asDate(input);
    return `0${date.getUTCHours()}`.slice(-2);
}
/**
 * Returns minute as integer. \
 * E.g. 37
 * @param {IsoAndUnixTimestamp} input
 * @returns
 */
function getMinute(input: Date): string;
function getMinute(input: IsoAndUnixTimestamp): string;
function getMinute(input: Date | IsoAndUnixTimestamp): string {
    const date = input instanceof Date ? input : asDate(input);
    return `0${date.getUTCMinutes()}`.slice(-2);
}
/**
 * Returns hhmm as integer. \
 * E.g. 0737
 * @param {IsoAndUnixTimestamp} input
 * @returns
 */
function getHourAndMinute(input: Date): string;
function getHourAndMinute(input: IsoAndUnixTimestamp): string;
function getHourAndMinute(input: Date | IsoAndUnixTimestamp): string {
    const date = input instanceof Date ? input : asDate(input);
    return `${getHour(date)}${getMinute(date)}`;
}
/**
 * Are the dates (yyyymmdd) the same?
 */
function isTheSameDate(
    date1: IsoAndUnixTimestamp,
    date2: IsoAndUnixTimestamp
): boolean {
    return toFullDate(date1) === toFullDate(date2);
}
/**
 * Are the dates (yyyymmdd) the same?
 */
function isTheSameHourAndMinute(
    dateTime1: IsoAndUnixTimestamp,
    dateTime2: IsoAndUnixTimestamp
): boolean {
    return getHourAndMinute(dateTime1) === getHourAndMinute(dateTime2);
}

const now = (): IsoAndUnixTimestamp => isoAndUnixFactory(new Date());

const dateTimeSort = (a: WithUnixTimestamp, b: WithUnixTimestamp) =>
    a.unix - b.unix;
const sortItemsByDateTime = <T extends Record<string, unknown>>(
    items: T[],
    iteratee: (item: T) => WithUnixTimestamp
) => {
    const sort = (a: T, b: T) => iteratee(a).unix - iteratee(b).unix;
    return Array.from(items).sort(sort);
};
const isBeforeNow = (value: WithUnixTimestamp) =>
    toUnix(new Date()) > value.unix;
const isBeforeToday = (input: WithUnixTimestamp) =>
    toFullDate(new Date()) > toFullDate(input);
const isInTheFuture = (value: WithUnixTimestamp) =>
    toUnix(new Date()) < value.unix;

// const dateTimeSchema = object().shape<DateTime>({
//     _type: string().oneOf(["DATE_TIME"]).required(),
//     iso: string<IsoTimestamp>().required().nullable(false),
//     unix: number<UnixTimestamp>().required().nullable(false),
//     fullDate: number().required().nullable(false),
//     dayOfMonth: number()
//         .required()
//         .nullable(false)
//         .oneOf(repeatIndex(31).map(num => num + 1)),
//     dayOfWeek: number().required().nullable(false).oneOf(repeatIndex(7)),
//     hour: number().required().nullable(false).oneOf(repeatIndex(24)),
//     quarter: number()
//         .required()
//         .nullable(false)
//         .oneOf(repeatIndex(4).map(ind => ++ind)),
//     half: number()
//         .required()
//         .nullable(false)
//         .oneOf(repeatIndex(2).map(ind => ++ind)),
//     minute: number().required().nullable(false).min(0).max(1440),
// });

export {
    now,
    sortItemsByDateTime,
    dateTimeSort,
    isBeforeNow,
    isInTheFuture,
    isInTheFuture as isAfterNow,
    isTheSameDate,
    isBeforeToday,
    isTheSameHourAndMinute,
    getMinute,
    getHour,
    getHourAndMinute,
};
